import InterventionLog from '@/models/InterventionLog.js';
import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Intervention extends Model {
    static entity = 'interventions';

    static modelName = 'Intervention';

    static fields() {
        return {
            id: this.attr(null),
            intervention_method_id: this.attr(null),
            user_id: this.attr(null),
            course_id: this.attr(null),
            course_enrollment_id: this.attr(null),
            meta_data: this.attr(null),
            user: this.attr(null),
            course: this.attr(null),
            created_at: this.attr(null),

            intervention_method: this.belongsTo('intervention_method', 'intervention_method_id'),
            statuses: this.morphMany('statuses', 'model_id', 'model_type_entity'),
            logs: this.hasMany('intervention_logs', 'intervention_id'),
        };
    }

    static queryBuilder() {
        return new QueryBuilder(this.entity);
    }

    static searchable() {
        return ['name'];
    }

    createLog(interventionLog) {
        const date = this.getFormattedDate();

        InterventionLog.insert({
            data: {
                ...interventionLog,
                intervention_id: this.id,
                created_at: date,
                updated_at: date,
            },
        });
    }

    static async create(data) {
        if (!data?.intervention_method || !data?.enrollment) {
            console.error("Invalid data: 'method' or 'enrollment' is missing", data);
            return;
        }

        const payload = {
            intervention_method_id: data.intervention_method?.id ?? null,
            user_id: data.enrollment?.user_id ?? null,
            course_id: data.enrollment?.course_id ?? null,
            course_enrollment_id: data.enrollment?.id ?? null,
        };

        const { response } = await this.api().post(this.queryBuilder().toUrl(), payload);

        return response;
    }

    static async fetch() {
        const query = this.queryBuilder()
            .include('user')
            .include('course')
            .include('interventionMethod')
            .include('logs');

        const { response } = await this.api().get(query.toUrl());

        return response.data.data;
    }

    static async fetchById(id) {
        const { response } = await this.api().get(this.queryBuilder(id).toUrl());

        return response.data;
    }

    async update(id, payload) {
        const { response } = await Intervention.api().put(`${Intervention.queryBuilder().toUrl()}/${id}`, {
            ...payload,
        });

        return response.data;
    }

    getFormattedDate() {
        const now = new Date();
        const year = now.getFullYear();
        const day = String(now.getDate()).padStart(2, '0'); // Ensure 2-digit format
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based

        return `${year}-${day}-${month}`;
    }
}
